import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import Box from '@mui/material/Box';
import { useDarkMode } from "utils/commonTheme";
import StrechBox from "components/StrechBox";

export default function LayoutDashboard({ strech }) {
  useDarkMode()

  const [strechSize, setStrechSize] = React.useState({ width: '100%', height: "100%" })
  const location = useLocation();
  React.useEffect(() => {
    if (location.pathname.startsWith('/dashboard'))
      setStrechSize({ width: 2600, height: 1800 })
    else if (location.pathname.startsWith('/gis'))
      setStrechSize({ width: 2600, height: 1800 })
    else if (location.pathname.startsWith('/module'))
      setStrechSize({ width: 5200, height: 1800 })
    else if (location.pathname.startsWith('/Link2SelectView'))
      setStrechSize({ width: 1600, height: 900 })
    else
      setStrechSize({ width: 1600, height: 900 })
  }, [location])

  return (
    <Box sx={{ position: 'relative', width: '100vw', height: '100vh' }}>
      {
        (location.pathname !== '/dashboard' && location.pathname !== '/gis' && location.pathname !== '/module' && location.pathname !== '/Link2SelectView') && strech ?
          <StrechBox width={strechSize.width} height={strechSize.height} enableDebugButton>
            <Outlet />
          </StrechBox>
          :
          <Outlet />
      }
    </Box>
  );
}